/*
 * @Author: tong.yu1@simceredx.com
 * @Date: 2022-12-16 13:13:47
 * @LastEditTime: 2022-12-29 13:22:21
 * @LastEditors: tong.yu1@simceredx.com
 * @Description: 
 * @FilePath: \git\simsysconfig\ssologin\src\pages\user\login\index.jsx
 * 可以输入预定的版权声明、个性签名、空行等
 */
import { Checkbox, Form, Input, Button } from 'antd';
import React, { useEffect } from "react";
import './index.scss';
import utils from 'utils/index';

import userService from 'services/user';
import UserLayout from 'layouts/UserLayout.jsx';

const Login = props=> {
    const [form] = Form.useForm()
    useEffect(() => {
        initPage()
    }, [])// eslint-disable-line react-hooks/exhaustive-deps
    const onFinish = (values)=>{
        const appCode = utils.getQueryString('appCode')
        const redirectUrl = utils.getQueryString('redirectUrl')
        userService.login({
            ...values,
            appCode,
            redirectUrl
        }).then(({code,data})=>{
            if(code===200&&!!data){


                  // 记住密码                  
                  
                //   if(this.state.isRemmbered || utils.getStorage("u_pwd")){ // checked, 曾经有旧密码
                //      utils.setStorage("u_pwd", values.password);
                //   }
                saveAccount(values)
                // history.push(data);
                window.location.href = data
                // window.open(data)
            }
        }).catch(err=>{
            console.log('err',err)
        })
    };
    
    const onFinishFailed = (errorInfo)=>{
        console.log('Failed:', errorInfo);
    };

    // 密码是否展示图标重新渲染
    const iconRender = (visible) => {
        return (
            visible ? <img src={utils.imgList.pwdOpenIcon} alt="图标" width='16px' style={{cursor:'pointer'}}/> : 
            <img src={utils.imgList.pwdCloseIcon} alt="图标" width='16px' style={{cursor:'pointer'}}/>
        )
    }

    // 记住账号密码
    const saveAccount = ({isRemembered,password,account}) => {
        // 记住账号密码
        if(isRemembered){ 
            // checked, 曾经有旧密码
            utils.setStorage("u_pwd", password)
            utils.setStorage("u_name", account)
        }else if(utils.getStorage("u_pwd")||utils.getStorage("u_name")){
            utils.setStorage("u_pwd", '')
            utils.setStorage("u_name", '')
        }
    }

    const initPage = () => {
        /**
         * 检测localstorage 是否有用户名、密码, 有就自动填充
         * {
         *  u_name: 用户名
         *  u_pwd: 密码
         * }
         *  */
        if (utils.getStorage('u_pwd')) {
          const ruleForm = {
            account: utils.getStorage('u_name'),
            password: utils.getStorage('u_pwd'),
            isRemembered: true
          }
          form.setFieldsValue(ruleForm)
        }
      }

    return (
        <UserLayout>
            <div className="main login-container">
                <div className="head-box">
                    <span className='tit-text'>Hello</span>
                    <span className="tit1">欢迎登录用户统一平台</span>
                </div>
                <Form
                    name='basic'
                    onFinish={(e)=>onFinish(e)}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                    className="formBox"
                    form={form}
                >
                    <Form.Item
                        name="account"
                        rules={[{ required: true, message: '请输入账号' }]}
                        className="inlineFormItem"
                    >
                        <Input 
                            placeholder="请输入账号" 
                            className="inputBox" 
                            bordered={false} 
                            addonBefore={<img src={utils.imgList.userIcon} alt="用户" className='login-icon'/>}
                        />
                    </Form.Item>

                    <Form.Item
                        name="password"
                        rules={[{ required: true, message: '请输入密码' }]}
                        className="inlineFormItem"
                    >
                        <Input.Password 
                            placeholder="请输入密码" 
                            className="inputBox"
                            bordered={false}
                            iconRender={iconRender}
                            addonBefore={<img src={utils.imgList.pwdIcon} alt="密码" className='login-icon'/>}
                        />
                    </Form.Item>

                    <Form.Item 
                        name="isRemembered" 
                        valuePropName="checked"
                        className="formBtnBox"
                        style={{marginTop:'-20px'}}
                    >
                        <Checkbox>记住账号密码</Checkbox>
                    </Form.Item>
                    <Form.Item style={{marginTop:'32px'}}>
                        <div>
                            <Button type="primary" htmlType="submit" className="submitBtn" block>
                            登 录
                            </Button>
                        </div>
                    </Form.Item>
                </Form>
            </div>
        </UserLayout>
    )
}

export default Login